<template>
    <v-sheet color="blue" elevation="8" class="pa-3" width="580">
        <h3 class="mb-4">{{ ip }}</h3>
        <v-row class="ma-0">
            <Hexagon class="mx-8" color="green" :title="hexaTitle1" subtitle="Mbps" :sizeTitle="35" :sizeSubTi="15" icon="mdi-chart-timeline-variant"/>
            <Hexagon class="mx-8" color="green" :title="hexaTitle2" :subtitle="t('labels.latency')" :sizeSubTi="15" :sizeTitle="25" icon="mdi-speedometer"/>
            <Hexagon class="mx-8" color="green" :title="hexaTitle3" :subtitle="t('labels.loss')" :sizeSubTi="15" :sizeTitle="25" icon="mdi-wifi-arrow-up"/>
            <Hexagon class="mx-8" color="green" :title="hexaTitle4" :subtitle="t('labels.uptime')" :sizeSubTi="15" :sizeTitle="25" icon="mdi-chart-bar"/>
        </v-row>
    </v-sheet>
</template>

<script setup lang="ts">
import Hexagon from '@/components/RAOS/HexagonRAOS.vue';

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

interface Props {
    hexaTitle1: string
    hexaTitle2: string
    hexaTitle3: string
    hexaTitle4: string
    ip: string
}

defineProps<Props>()

</script>